import { getToken, getClientDomain, translate } from '../../../../utils/Common';
import AuthContext from '../../../../contexts/auth';
import { useContext, useEffect, useState } from 'react';
import Spinner from '../../../../components/Spinner';
// components
// import Tooltip from '../../../../../components/Tooltip';

// para buscar clientes
const SearchClient = (props) => {
    const userContext = useContext(AuthContext);
    const [selectedClient, setSelectedClient] = useState(null);
    const [idSelectClient, setIdSelectedClient] = useState('');

    const getClients = async () => {        
        try {
            props.clearErrors();

            const abortController = new AbortController();
            const response = await fetch(`${getClientDomain(2)}/dashboard/clients/search` , {
                method: 'POST',
                connection: 'keep-alive',
                accept: 'application/json',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': `Bearer ${getToken()}`
                },
                body: JSON.stringify({ 
                    buscarCliente: (props.buscarCliente ? props.buscarCliente.toUpperCase() : null),
                    idUsuario: props?.idUsuarioSelected ?? userContext.user?.Ruc,
                    idTipoCliente: props.idTipoCliente
                 }),
                signal: abortController.signal
            });

            const result = await response.json();
            if (result) {
                if (result.code === 200) {
                    if (result.payload) {
                        if (result.payload?.length > 0){
                            const idClientSelect = result.payload[0]?.IdCliente;
                            props.handleSelectClientes(result.payload);
                            setSelectedClient(result.payload[0]);
                            setIdSelectedClient(idClientSelect);
                            props.handleSelectedClient(idClientSelect);
                            props.handleBuscarCliente('');
                        } else{
                            props.handleSelectClientes([]);
                            setSelectedClient(null);
                            setIdSelectedClient('');
                            props.handleBuscarCliente('');
                        } 
                    } else {
                    props.handleSelectClientes([{ PrimerNombre: translate("global.thereNone"), PrimerApellido: translate("global.providers")}]);
                    props.handleBuscarCliente('');
                    setSelectedClient(null);
                    setIdSelectedClient('');
                }
                }
                else {
                    props.setError('buscarCliente', {
                        type: '',
                        message: translate("dashboard.packages.loadpackage.searchClient.noData")
                    });
                    props.handleSelectClientes(null);
                }
            }
        } catch (error) {
            console.log(error);
            props.setError('buscarCliente', {
                type: '',
                message: translate("dashboard.packages.loadpackage.searchClient.error")
            });
        }
    }

    useEffect(() => {
        getClients();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.idUsuarioSelected]);

    useEffect(() => {
        // Cuando se actualiza props.selectClientes, seleccionar automáticamente el primer cliente
        if (props.selectClientes && props.selectClientes.length > 0) {
            setSelectedClient(props.selectClientes[0]);
            setIdSelectedClient(props.selectClientes[0]?.IdCliente);

            props.handleSelectedClient(props.selectClientes[0]?.IdCliente);
        }
    }, [props.selectClientes]);

    return  <>
                <div className={ "flex flex-wrap -mx-2 " + (props?.from === 'changeClient' ? "mx-3" : "mx-0")}>

                    {
                        props.isProvider && props.idUsuarioSelected && (
                            <div className="mb-3 sm:w-12/12 md:w-6/12 mb-1">
                            <label htmlFor="inputBuscarcliente" className={ "mb-1 " + (props?.from === 'changeClient' ? "mt-1" : "mt-2")}>
                            {translate("global.search")+" "+translate("global.client")}: 
                            </label>
                            <input className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm" value={ props.buscarCliente ? props.buscarCliente : '' }
                                onChange={ (e) => props.handleBuscarCliente(e.target.value ? e.target.value : '') } 
                                type="text" name="buscarCliente" 
                                disabled={!props.selectClientes}
                                title="Nombre, apellido o número de cliente" ref={ props.register } />
                            { props.errors.buscarCliente && <span className="text-destructive text-xs">{props.errors.buscarCliente.message}</span> }
                        </div>
                        )
                    }
                   

                    

                        <div className="mb-3 sm:w-12/12 md:w-6/12 mb-1">
                
                            <label htmlFor="selectCliente" className={ "mb-1 " + (props?.from === 'changeClient' ? "mt-1" : "mt-2")}><span className="text-destructive font-semibold">*</span> {translate("global.client")}:</label>
                            <select className="h-11 rounded-lg border border-transparent bg-muted/60 text-sm w-full px-3 text-foreground placeholder:text-muted-foreground/70 focus-visible:outline-none focus-visible:border-primary focus-visible:bg-background focus-visible:ring-4 focus-visible:ring-primary/15 disabled:bg-transparent disabled:text-muted-foreground disabled:cursor-not-allowed h-9 text-sm text-sm" id="selectCliente" name="cliente" ref={ props.register({
                                validate: value => value !== ("Seleccione" || "No hay clientes") || 'Debes elegir un cliente válido.'
                            }) } 
                            onChange={(e) => {
                                props.handleSelectedClient(e.target.value); 
                                setIdSelectedClient(e.target.value);
                            }} 
                            
                            value={idSelectClient} disabled={!props.selectClientes}
                        >
                                {/* { props.selectClientes } */}
                                <option defaultValue>{translate("global.select")}</option>
                                { props.selectClientes?.length > 0 && props.selectClientes.map((cliente, index) => <option key={ cliente?.IdCliente } value={ cliente.IdCliente } onClick={()=>{setIdSelectedClient(cliente.IdCliente)}}>{ `${cliente.IdCliente} - ${cliente.Nombre} ${cliente.Apellidos}` }</option> ) }
                            </select>
                            { props.errors.buscarCliente && <span className="text-destructive text-xs">{props.errors.buscarCliente.message}</span> }
                            { !props.selectClientes && !props.errors.buscarCliente && <div style={{ marginTop:"12px", display:"flex", alignItem:"center"}}>
                            <Spinner  type={1} size={15} />
                         </div>}         
                    </div>
                    
                    
                </div>

                <div className={ "flex flex-wrap -mx-2 " + (props?.from === 'changeClient' ? "mx-3 mb-2" : "mx-0")}>
                    { props.buscarCliente && props.buscarCliente !== '' &&
                        <div className="mb-3 sm:w-12/12 md:w-6/12 mt-1 mb-1">
                            <button className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 h-10 px-4 py-2 border border-secondary bg-transparent text-secondary hover:bg-secondary hover:text-secondary-foreground h-8 rounded-md px-3 text-xs" type="button" onClick={ () => getClients() }>{translate("global.search")+" "+translate("global.client")}</button>
                        </div>
                    }
                </div>
            </>
}

export default SearchClient;